import React from 'react'
import AdminNavigation from '../AdminNavigation/AdminNavigation'

function AdminHome() {
  return (
    <div>
      <AdminNavigation/>
      <section>
      <h2>Dashboard</h2>
      <p>Welcome to the admin dashboard. </p>
    </section>
    </div>
  )
}

export default AdminHome
